import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndex } from "../../organisations/model/OrganisationIndex";
import OrganisationIndexMapper from "../../organisations/service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../../organisations/service/OrganisationIndexParamMapper";

export default class GetCaseLawDocumentIndexesInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisationIndex>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(id: number) {
    return this.resource.execute(
      "/case-law-documents/indexes",
      OrganisationIndexMapper,
      OrganisationIndexParamMapper,
      {
        params: { id }
      }
    );
  }
}
